import { render } from "./personal.vue?vue&type=template&id=38602bc9"
import script from "./personal.vue?vue&type=script&lang=js"
export * from "./personal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/commerce/central/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__